import React from 'react';
import { MultiSelect } from "react-multi-select-component";

const MultiSelectListBox = ({ options, selected, onSelectionChange, disable=false }) => {
    //const [selected, setSelectedFilters] = useState([]);

    return (
    <div style={multiSelStyle}>
      <MultiSelect
        options={options}
        value={selected}
        onChange={onSelectionChange}
        labelledBy={"Select"}
		disabled={disable}
      />
    </div>
	);
};

const multiSelStyle = {
	width: '50%',
	margin: '10px auto',
	color: '#233D62'
};

export default MultiSelectListBox;
